import React, { Component } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
// import { Switch, Route, Link } from 'react-router-dom';

import Header from '../Header/header';
import Footer from '../Footer/footer';

import {getRoles, GetMenuHeader} from '../../functions';
import axios from 'axios';
import cookie from 'react-cookies';
import {API_URL} from '../../constants';
import Menu from '../Menu/menu';

import Routes from './routes';
import { UnsavedChangesProvider } from './UnsavedChangesContext';

//const ele = document.getElementById('ipl-progress-indicator');

class Root extends Component {

  constructor(props){
      super(props);
      this.state = {
          menu: [],
          menuGeneral: [],
          security: cookie.load('user'),
      } 
  }

  componentDidMount(){
    // localStorage.setItem("user", null);
    // cookie.remove('user', { path: '/'}) 

    //var menudata = getRoles(cookie.load('menu'));
    //console.log(menudata);
    
    var roles = getRoles(cookie.load('user'));
    const ele = document.getElementById('ipl-progress-indicator');
    if(ele){ele.classList.add('available');}

    var rol = roles.length > 0 ? roles[0].nRolCodigo : null;
    // const url = `${API_URL}MenuUX/${rol}`;
    const url = API_URL + `OpcionUX/GetOptionsByUser/${this.state.security.nUsuCodigo}`;

    axios.get(url).then(response => response.data)
    .then(async (data) => {

        /*
          let menuTemp = [{
              sAgrupador:"Administradores",
              sOpcNombre:"Menus",
              sUrl:"/menu"
            },
            {
              sAgrupador:"Administradores",
              sOpcNombre:"Categorias de Certificaciones",
              sUrl:"/categorias-certificacion"
            },
            {
              sAgrupador:"Administradores",
              sOpcNombre:"Categorías de Exporta Fácil",
              sUrl:"/categorias-exporta-facil"
            },
            {
              sAgrupador:"Administradores",
              sOpcNombre:"Categorías de Preguntas Frecuentes",
              sUrl:"/categorias-faq"
            },
            {
              sAgrupador:"Administradores",
              sOpcNombre:"Categorías de Herramientas de Análisis",
              sUrl:"/categorias-herramienta-analisis"
            },
            {
              sAgrupador:"Administradores",
              sOpcNombre:"Categorías de Puede Interesarte",
              sUrl:"/categorias-puede-interesarte"
            },
            {
              sAgrupador:"Administradores",
              sOpcNombre:"Adm. de Páginas",
              sUrl:"/paginas"
            },
            {
              sAgrupador:"Administradores",
              sOpcNombre:"Adm. de H. de Análisis",
              sUrl:"/herramientas-analisis"
            },
            {
              sAgrupador:"Administradores",
              sOpcNombre:"Adm. de Certificaciones",
              sUrl:"/certificaciones"
            },
            {
              sAgrupador:"Administradores",
              sOpcNombre:"Adm. de Oficinas en el Mundo",
              sUrl:"/oficinas-mundo"
            },
            {
              sAgrupador:"Administradores",
              sOpcNombre:"Adm. También Puede Interesarte",
              sUrl:"/puede-interesarte"
            },
            {
              sAgrupador:"Administradores",
              sOpcNombre:"Adm. de Documentación para Exportar",
              sUrl:"/documento-exportacion"
            },
            {
              sAgrupador:"Administradores",
              sOpcNombre:"Adm. de Guías para el Exportador",
              sUrl:"/guia-exportador"
            },
            {
              sAgrupador:"Administradores",
              sOpcNombre:"Adm. de Categorías Potencial de Exportación",
              sUrl:"/categorias-potencial-exportador"
            },
            {
              sAgrupador:"Administradores",
              sOpcNombre:"Adm. Exporta Fácil",
              sUrl:"/exporta-facil"
            },
            {
              sAgrupador:"Administradores",
              sOpcNombre:"Adm. Productos Priorizados por Sector y Mercado",
              sUrl:"/productos-priorizado"
            },
            {
              sAgrupador:"Administradores",
              sOpcNombre:"Adm. de H. para Pymes",
              sUrl:"/herramientas-pyme"
            },
            {
              sAgrupador:"Administradores",
              sOpcNombre:"Adm. H. Externas",
              sUrl:"/herramientas-externa"
            },
            {
              sAgrupador:"Administradores",
              sOpcNombre:"Adm. de Programas de Capacitación",
              sUrl:"/programas-capacitacion"
            },
            {
              sAgrupador:"Administradores",
              sOpcNombre:"Adm. de Glosarios",
              sUrl:"/glosario"
            },
            {
              sAgrupador:"Administradores",
              sOpcNombre:"Adm. FAQ",
              sUrl:"/faqs"
            },
            {
              sAgrupador:"Usuarios",
              sOpcNombre:"Usuarios",
              sUrl:"/usuarios"
            },
            {
              sAgrupador:"Usuarios",
              sOpcNombre:"Roles",
              sUrl:"/perfiles"
            },
            {
              sAgrupador:"Reportes",
              sOpcNombre:"Encuestas",
              sUrl:"/reporte-encuesta"
            },
            {
              sAgrupador:"Reportes",
              sOpcNombre:"Logs",
              sUrl:"/reporte-logs"
            },
            {
              sAgrupador:"Reportes",
              sOpcNombre:"Suscriptor",
              sUrl:"/reporte-suscriptor-footer"
            },
            {
              sAgrupador:"Reportes",
              sOpcNombre:"Trazabilidad",
              sUrl:"/reporte-trazabilidad"
            },
            {
              sAgrupador:"Configuradores",
              sOpcNombre:"Panel de Configuración",
              sUrl:"/configuradores"
            }
          ];

          menuTemp.map((menu) => (
            data.result.push(menu)
          ))
        */
        
        var menu = await GetMenuHeader(data.result);
        ele.classList.remove('available');
        localStorage.setItem("usermenu", JSON.stringify(menu));

        //console.log("MENU", data.result);
        // console.log("MENU DATA", menu);
        
        this.setState({
          menu: menu, 
          menuGeneral: data.result
        });

    }).catch(error => {
        // console.log(error);
    });
  }
  
  render() {
    return (
      <Router>
          <UnsavedChangesProvider>
          <div className="divContenedor_Panel">
          
            <Header></Header>

            <div className="divRowContenedor_Panel" id="wrapper">
                {
                    this.state.menu.length > 0 ?
                      <Menu 
                        menus={this.state.menu}
                      ></Menu>
                    : null
                }

                {this.state.menu.length > 0 &&
                  <Routes 
                    menu={this.state.menu} 
                    menuGeneral={this.state.menuGeneral} 
                  />
                }

            <Footer></Footer>
            </div>
          </div>
          </UnsavedChangesProvider>
      </Router>
    );
  }

}
 
export default Root;


